
import { defineComponent, ref, onMounted } from 'vue'

import { useRoute } from 'vue-router';
import eventService from '@/core/services/PublicService';
import { errManager } from "@/core/config/Tools";

export default defineComponent({
    name: "public-medals-sports",
    setup() {
        const route = useRoute();
        const { id } = route.params
        const loading = ref(false)
        const listMedals = ref<any>([])
        const sport = ref<any>({})


        const getListMedals = async () => {
            loading.value = true
            await eventService.MedalleroSport('1', atob(id.toString()))
                .then((res) => {
                    sport.value = res.data.sport
                    listMedals.value = res.data.medallas
                    loading.value = false
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        onMounted(() => {
            getListMedals()
        })

        return {
            id,
            loading,
            sport,
            listMedals,
            getListMedals

        }

    },
})
